import React, { useState } from 'react';
import { categoriaDeTipo } from './metricas';
import type { ConfigAnalisis, ReglaTipo } from './tipos';
import { CHIP, COLOR_CATEGORIA, btnSecundario } from './ui';

const GRUPOS: Array<{ regla: ReglaTipo; titulo: string }> = [
  { regla: 'rehacer', titulo: 'Rehacen siempre' },
  { regla: 'no_rehacer', titulo: 'No rehacen por sí solos' },
  { regla: 'pedir_fotos', titulo: 'Piden fotos' },
];

/**
 * Las reglas con las que el backend decide (solo lectura), colapsables. Están acá para
 * que al mirar un resultado se entienda POR QUÉ dijo regenerar / pedir fotos sin ir a
 * buscar el código del backend. Solo puntaje general + TIPO: no hay severidad por error.
 */
const ReglasDecision: React.FC<{ config: ConfigAnalisis }> = ({ config }) => {
  const [abierto, setAbierto] = useState(false);
  const porRegla = new Map<ReglaTipo, string[]>();
  for (const r of config.reglas_decision) porRegla.set(r.regla, [...(porRegla.get(r.regla) ?? []), r.tipo]);
  const conocidas = new Set<string>(GRUPOS.map((g) => g.regla));
  const desconocidas = config.reglas_decision.filter((r) => !conocidas.has(r.regla));

  return (
    <div>
      <button type="button" onClick={() => setAbierto((v) => !v)} className={`${btnSecundario} py-1.5 px-3 text-xs`}>
        {abierto ? 'Ocultar reglas' : 'Reglas de decisión'}
      </button>
      {abierto && (
        <div className="mt-2 space-y-2 rounded-lg bg-gray-50 p-3 text-xs">
          <p className="text-gray-600">
            Fidelidad ≤ <b className="text-brand-black">{config.fidelidad_regenerar}</b> (escala 1–{config.fidelidad_max}) → <b className="text-brand-black">regenerar</b>.
            Después, solo por el tipo de error detectado (sin puntaje por ítem):
          </p>
          {GRUPOS.map((g) => {
            const tipos = porRegla.get(g.regla) ?? [];
            if (tipos.length === 0) return null;
            return (
              <div key={g.regla}>
                <div className="mb-1 font-medium text-brand-black">{g.titulo}</div>
                <div className="flex flex-wrap gap-1">
                  {tipos.map((t) => (
                    <span key={t} className={`${CHIP} ${COLOR_CATEGORIA[categoriaDeTipo(t)]}`}>
                      {t}
                    </span>
                  ))}
                </div>
              </div>
            );
          })}
          {desconocidas.length > 0 && (
            <p className="text-gray-500">
              Reglas que esta UI no conoce: {desconocidas.map((r) => `${r.tipo} (${r.regla})`).join(', ')}
            </p>
          )}
          {config.reglas_decision.length === 0 && <p className="text-gray-500">El backend no publicó reglas.</p>}
        </div>
      )}
    </div>
  );
};

export default ReglasDecision;
